var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoDefine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 4.66653H6.66667L9.33333 2L12 4.66653H10V7.61971C9.5 7.92636 9.05333 8.30634 8.66667 8.74632V4.66653ZM7.6 11.3329H6.33333L5.86667 9.99959H3.73333L3.26667 11.3329H2L4.13333 5.33316H5.46667L7.6 11.3329ZM5.56667 9.09963L4.8 6.66643L4.03333 9.09963H5.56667ZM16 8.66632L13.3333 5.99979V7.99969C10.9267 7.89969 8.87333 9.71293 8.66667 12.1128C7.62667 12.4795 7.08 13.6261 7.44667 14.666C7.81333 15.706 8.96 16.2526 10 15.8859C11.04 15.5126 11.5867 14.3727 11.22 13.3327C11.02 12.7594 10.5667 12.3128 10 12.1128C10.3133 9.44628 12.98 9.31296 13.3 9.31296V11.3129L16 8.66632Z",
    className: "fill auto-define"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDefine);
export default __webpack_public_path__ + "static/media/auto-define.60f4a597c3431a5f9c35d6f20ebac586.svg";
export { ForwardRef as ReactComponent };